<template>
  <div class="contais">
    <!-- 头部表单栏 -->
    <div class="cont_head flex_center">
      <div class="cont_heads">
        <h3>
          票号：
          <input
            type="text"
            v-model="piaonum"
            id="piao"
            placeholder="请填写票号"
            maxlength="12"
          />
        </h3>
        <h2>汽车业务建当</h2>
        <h3>填表日期：{{ dates }}</h3>
      </div>
    </div>

    <!-- 底下建当信息栏 -->
    <div class="con_tens">
      <div class="con_na">
        <!-- 第一步 -->
        <div v-if="testShow == 1">
          <span>车主和车辆信息：</span>
          <!-- 车主信息 -->
          <table width="100%">
            <!-- 第一行表格 -->

            <tr height="50px">
              <td width="15%" class="vereist">*车主</td>
              <td>
                <input type="text" v-model="name" />
              </td>
              <td width="15%" class="vereist">*车辆状态</td>
              <td colspan="5">
                <el-radio v-model="radio" label="全款无负债" @change="raDi"
                  >全款无负债</el-radio
                >
                <el-radio v-model="radio" label="全款无负债（未解押）" @change="raDi"
                  >全款无负债（未解押）</el-radio
                >
                <el-radio v-model="radio" label="抵押按揭车" @change="raDi"
                  >抵押按揭车</el-radio
                >
                <el-radio v-model="radio" label="查封车" @change="raDi">查封车</el-radio>
                <el-radio v-model="radio" label="其他" @change="raDi">其他</el-radio>
              </td>
            </tr>

            <!-- 第二行表格 -->
            <tr height="40px">
              <td class="vereist">*身份证号</td>
              <td colspan="1">
                <input type="text" v-model="IdCard" />
              </td>
              <td class="vereist">*通信地址</td>
              <td colspan="2">
                <input type="text" v-model="address" />
              </td>
              <td class="vereist">*联系电话</td>
              <td>
                <input type="text" v-model="tel" maxlength="11" />
              </td>
            </tr>

            <!-- 第三行表格 -->
            <tr>
              <td rowspan="2">车贷详情</td>
              <td rowspan="2" class="vereist">*抵押债券人</td>
              <td class="vereist" rowspan="2">
                <input type="text" v-model="creditor" placeholder="无抵押请写无" />
              </td>
              <td class="vereist">*车贷总额(元)</td>
              <td>
                <input type="number" v-model="price" placeholder="无车贷请写0" />
              </td>
              <td class="vereist">*月供(元)</td>
              <td>
                <input type="number" v-model="repayment" placeholder="无车贷请写0" />
              </td>
            </tr>

            <!-- 第四行表格 -->
            <tr>
              <td class="vereist">*车贷余额(元)</td>
              <td>
                <input type="number" v-model="remaining" placeholder="无车贷请写0" />
              </td>
              <td class="vereist">剩余期数</td>
              <td>
                <input type="number" v-model="RestPeriods" placeholder="无车贷请写0" />
              </td>
            </tr>
          </table>

          <!-- 车辆信息 -->
          <table width="100%">
            <tr>
              <td rowspan="6" width="15%">车辆详情</td>
              <td width="20%" class="vereist">*购车总额(元)</td>
              <td>
                <input type="number" v-model="total" />
              </td>
              <td colspan="2" class="vereist">*发票价(元)</td>
              <td>
                <input type="number" v-model="invoiceCost" />
              </td>
            </tr>

            <tr>
              <td class="vereist">*过户次数</td>
              <td>
                <input
                  type="number"
                  v-model="transferOwnership"
                  placeholder="无过户记录请写0"
                />
              </td>
              <td colspan="2">品牌</td>
              <td>
                <input type="text" v-model="brand" />
              </td>
            </tr>
            <tr>
              <td class="vereist">*车牌号码</td>
              <td>
                <input type="text" v-model="plateNumber" placeholder="字母请大写" />
              </td>
              <td colspan="2">型号</td>
              <td>
                <input type="text" v-model="models" />
              </td>
            </tr>
            <tr>
              <td>发动机号</td>
              <td>
                <input type="text" v-model="engineNumber" />
              </td>
              <td colspan="2">车架号</td>
              <td>
                <input type="text" v-model="vin" />
              </td>
            </tr>
            <tr>
              <td>车身颜色</td>
              <td>
                <input type="text" v-model="carColor" />
              </td>
              <td colspan="2">能源类型</td>
              <td>
                <el-radio v-model="radio2" label="燃油" @change="raDias">燃油</el-radio>
                <el-radio v-model="radio2" label="纯电" @change="raDias">纯电</el-radio>
                <el-radio v-model="radio2" label="其他" @change="raDias">其他</el-radio>
              </td>
            </tr>
            <tr>
              <td class="vereist">*注册日期</td>
              <td>
                <input type="text" v-model="recordDate" />
              </td>
              <td colspan="2" class="vereist">*行驶里程</td>
              <td>
                <input type="number" v-model="mileage" />
              </td>
            </tr>
          </table>
        </div>

        <!-- 第二步 -->

        <div v-if="testShow == 2">
          <span>证件信息和现场查验估值：</span>
          <!-- 核对证件 -->
          <table width="100%">
            <tr>
              <td rowspan="4" width="15%">核对证件</td>
              <td width="15%">证件</td>
              <td>
                <el-checkbox-group v-model="checkList" @change="checkLists">
                  <el-checkbox label="车辆登记证书"></el-checkbox>
                  <el-checkbox label="行驶证"></el-checkbox>
                  <el-checkbox label="车主身份证"></el-checkbox>
                  <el-checkbox label="购车发票"></el-checkbox>
                  <el-checkbox label="车贷合同或有关证明"></el-checkbox>
                  <el-checkbox label="还贷流水"></el-checkbox>
                  <el-checkbox label="备用钥匙"></el-checkbox>
                  <el-checkbox label="征信"></el-checkbox>
                  <el-checkbox label="车险资料"></el-checkbox>
                </el-checkbox-group>
              </td>
            </tr>
            <tr>
              <td class="vereist">*交强险到期日期</td>
              <td>
                <input type="text" v-model="StrongRisk" />
              </td>
            </tr>
            <tr>
              <td class="vereist">*商业险到期日期</td>
              <td>
                <input type="text" v-model="commercialInsurance" />
              </td>
            </tr>
            <tr>
              <td class="vereist">*违章未处理</td>
              <td>
                <input
                  type="text"
                  v-model="IllegalProcessing"
                  placeholder="没有违章请填写无"
                />
              </td>
            </tr>
          </table>

          <!-- 现实查验 -->
          <table width="100%">
            <tr>
              <td rowspan="5" width="15%">现场查验</td>
              <td width="15%" class="vereist">*1.是否事故车</td>
              <td width="17%">
                <el-radio v-model="radio1" label="是" @change="raDia">是</el-radio>
                <el-radio v-model="radio1" label="否" @change="raDia">否</el-radio>
              </td>
              <td width="15%">2.外观</td>
              <td>
                <input type="text" v-model="facade" />
              </td>
              <td rowspan="6" width="20%">
                <img class="carimg" src="@/assets/cars.png" alt="" />
              </td>
            </tr>
            <tr>
              <td>3.发动机</td>
              <td>
                <input type="text" v-model="engine" />
              </td>
              <td>4.底盘</td>
              <td>
                <input type="text" v-model="chassis" />
              </td>
            </tr>
            <tr>
              <td>5.冷却系统</td>
              <td>
                <input type="text" v-model="coolingSystem" />
              </td>
              <td>6.电气系统</td>
              <td>
                <input type="text" v-model="electricalSystem" />
              </td>
            </tr>
            <tr>
              <td>7.制动系统</td>
              <td>
                <input type="text" v-model="brakingSystem" />
              </td>
              <td>8.试驾情况</td>
              <td>
                <input type="text" v-model="testDrive" />
              </td>
            </tr>
            <tr>
              <td>9.内饰</td>
              <td>
                <input type="text" v-model="trim" />
              </td>
              <td>10.能源余值</td>
              <td>
                <input type="text" v-model="energy" />
              </td>
            </tr>
            <tr>
              <td>综合车况</td>
              <td colspan="4">
                <el-rate
                  v-model="values"
                  show-text
                  :max="3"
                  :texts="texts"
                  @change="compreHensive"
                >
                </el-rate>
                <div class="vereist">
                  *经办人意见：<input
                    type="text"
                    v-model="opinion"
                    placeholder="点击这里输入意见"
                  />
                </div>
              </td>
            </tr>
          </table>

          <!-- 市场及第三方估值 -->
          <table width="100%">
            <tr>
              <td rowspan="4" width="15%">(制表日)市场及第三方估值</td>
              <td class="vereist" width="15%">*新车在售价(元)</td>
              <td>
                <input type="number" v-model="NewCarPrice" />
              </td>
              <td class="vereist" width="10%">*保值率</td>
              <td>
                <input type="text" v-model="keepValue" />
              </td>
              <td class="vereist">*客户借款期望值</td>
              <td>
                <input type="number" v-model="expect" />
              </td>
            </tr>
            <tr>
              <td rowspan="3" class="vereist">*（第三方）转让过户参考价（取平均值）</td>
              <td colspan="2" class="vereist">
                *1.（车300）
                <input type="number" v-model="vehicles" placeholder="请输入车300的估价" />
              </td>
              <td colspan="2" rowspan="3" class="vereist">
                *车辆余值 (二手市场价减去车辆负债减去违章)
              </td>
              <td rowspan="3">
                <input type="number" v-model="residualValue" />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="vereist">
                *2.（汽车之家）
                <input type="number" v-model="atHm" placeholder="请输入汽车之家的估价" />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="vereist">待接入</td>
            </tr>
          </table>
        </div>

        <!-- 第三步 -->
        <div v-if="testShow == 3">
          <span
            >典当信息：
            <span class="vereist">*注意典当综合费率和利息建当后不可修改* </span>
          </span>
          <!-- 价值反馈 -->
          <table width="100%">
            <tr>
              <td class="vereist">*当物估值(元)</td>
              <td>
                <input
                  type="number"
                  v-model="overallValuation"
                  placeholder="请输入汽车的最终估值"
                />
              </td>
              <td class="vereist">*折当率</td>
              <td>
                <input type="text" v-model="FoldWhen" />
              </td>
              <td class="vereist">*停车费</td>
              <td>
                <input type="number" v-model="parkingFee" />
              </td>
            </tr>
            <tr height="50px">
              <td class="vereist">*典当金额(元)</td>
              <td>
                <input type="number" v-model="sum" />
              </td>
              <td class="vereist">*典当日期</td>
              <td colspan="1">
                <!-- 续当分期/
                  <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{command}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="6期">6期</el-dropdown-item>
                    <el-dropdown-item command="12期">12期</el-dropdown-item>
                    <el-dropdown-item command="24期">24期</el-dropdown-item>
                    <el-dropdown-item command="36期">36期</el-dropdown-item>
                    <el-dropdown-item command="48期">48期</el-dropdown-item>
                    <el-dropdown-item command="60期">60期</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> -->

                <el-date-picker
                  v-model="detaValue"
                  type="daterange"
                  align="right"
                  unlink-panels
                  size="large"
                  range-separator="至"
                  start-placeholder="开始典当日期"
                  end-placeholder="典当到期日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="chang"
                  class="picker"
                >
                </el-date-picker>
              </td>
              <td>典当天数</td>
              <td>
                {{ this.det }}
              </td>
            </tr>
            <!-- <tr>
                <td>典当开始日期</td>
                <td>{{dateDay}}</td>
                <td>到期日期</td>
                <td>{{expiringDate}}</td>
                <td>续当计划表</td>
                <td><el-button type="primary" size="mini">查看续当计划表</el-button></td>
              </tr> -->
            <tr>
              <td class="vereist">*填写综合费率(%)</td>
              <td colspan="3">
                <input type="number" v-model="priceZ" placeholder="请输入典当综合费" /> %
              </td>
              <td class="vereist">*填写典当利率(%)</td>
              <td colspan="2">
                <input type="number" v-model="interest" placeholder="请输入典当利息" />%
              </td>
            </tr>
            <tr height="80px">
              <td colspan="6">
                *经办人（署名）：

                {{ username }}
              </td>
            </tr>
          </table>
        </div>

        <div v-if="testShow == 4">
          <!-- class="btn_tj" -->
          <div id="print">
            <span>分期信息：</span>

            <table width="100%">
              <tr>
                <td style="font-size: 20px; font-weight: bold" colspan="9">
                  典当续当协议({{ isType ? "1+N方案" : "0+N方案" }})
                </td>
              </tr>
              <tr>
                <td
                  colspan="9"
                  style="background-color: #7cc1de; font-size: 20px; height: 65px"
                >
                  当户 {{ name }} {{ piaonum }} 汽车典当分期续当计划表，约定详见如下表格
                </td>
              </tr>
              <tr>
                <td width="15%">续当期数</td>
                <td width="15%">本金</td>
                <td width="10%" style="background-color: yellow">{{ sum }}</td>
                <td width="10%"></td>
                <td width="10%">综合费</td>
                <td width="10%">典当利息</td>
                <td rowspan="2" width="10%">付款日期</td>
                <td rowspan="2" width="10%">应付金额 （不含利息）</td>
                <td rowspan="2" width="10%">综合费率 （实际）</td>
              </tr>

              <tr>
                <td style="background-color: yellow">
                  <el-dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                      {{ command + "期"
                      }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="0期">0期</el-dropdown-item>
                      <el-dropdown-item command="6期">6期</el-dropdown-item>
                      <el-dropdown-item command="12期">12期</el-dropdown-item>
                      <el-dropdown-item command="24期">24期</el-dropdown-item>
                      <el-dropdown-item command="36期">36期</el-dropdown-item>
                      <el-dropdown-item command="48期">48期</el-dropdown-item>
                      <el-dropdown-item command="60期">60期</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </td>
                <td></td>
                <td>每期归还本金</td>
                <td>剩余本金</td>
                <td style="background-color: yellow">
                  {{ priceZ + "%" }}
                  <!-- <input type="text" v-model="priceZ" />% -->
                </td>
                <td style="background-color: yellow">
                  <!-- <input type="text" v-model="interest" />% -->
                  {{ interest + "%" }}
                </td>
              </tr>

              <tr v-if="isType">
                <td></td>
                <td>建当首期</td>
                <td>0</td>
                <td>{{ sum }}</td> 
                <td>{{ Math.trunc(sum * (priceZ / 100)) }}</td>
                <td>{{ Math.trunc(sum * (interest / 100)) }}</td>
                <td>{{ detaValue[0] }}</td>
                <td>{{ sum }}</td>
                <td>{{ ((((sum * (priceZ / 100)) + (sum * (interest / 100))) / sum) * 100).toFixed(2) + "%" }}</td>
              </tr>
            </table>

            <table width="100%" v-for="item in arrNum" :key="item">
              <tr>
                <td width="15%"></td>
                <td width="15%">第{{ item }}期</td>
                <td width="10%">{{ Math.trunc(sum / command) }}</td>
                <td width="10%">{{ sum - Math.trunc((sum / command) * item) }}</td>
                <td width="10%">
                  {{
                 
                    Math.trunc(
                      (sum - Math.trunc((sum / command) * item)) * (priceZ / 100)
                    )
                  }}
                </td>
                <td width="10%">
                  {{
                   
                    Math.trunc(
                      (sum - Math.trunc((sum / command) * item)) * (interest / 100)
                    )
                  }}
                </td>
                <td width="10%">{{ payDate(item * 29) }}</td>
                <td width="10%">
                  {{
                   
                    item == command
                      ? Math.trunc(sum / command)
                      : Math.trunc(sum / command) +
                        Math.trunc(
                          (sum - Math.trunc((sum / command) * item)) * (priceZ / 100)
                        )
                  }}
                </td>
                <!-- item > command / 2 ? Math.round(sum / command) + Math.round((sum - Math.round((sum / command) * item)) * 0.02)
                      : Math.round(sum / command) + sum * 0.02 -->
                <td width="10%">
                  {{
                    
                    item == command
                      ? "0.00%"
                      : (
                          (Math.trunc(
                            ((sum - Math.trunc((sum / command) * item)) * (priceZ / 100)) +   ((sum - Math.trunc((sum / command) * item)) * (interest / 100))
                          )   /
                            (sum - Math.trunc((sum / command) * item))) * 100
                        ).toFixed(2) + "%"
                  }}
                </td>
                <!-- item > command / 2 ? ((((sum - Math.round((sum / command) * item)) * 0.02) /(sum - Math.round((sum / command) * item))) * 100).toFixed(2) + "%"
                      : (
                          ((sum * 0.02) / (sum - Math.round((sum / command) * item))) *
                          100
                        ).toFixed(2) + "%" -->
              </tr>
            </table>
            <table width="100%">
              <tr height="100px">
                <td>
                  续当约定：{{
                    this.isType == true
                      ? "本业务确定为 “1+N”意思第二期起还本"
                      : "本业务确定为 “0+N” ，意思首期起还本"
                  }}
                  2，每期在付款日期前（含）支付部分本金、典当综合费；参照选定续当期数，上半段期数典当综合费按建当金额，以固定费率2%收取综合费；下半段续当期数每期按剩余当金，以月综合费率2%计收综合费；任何一期逾期续费按最高标准典当月费率4.2%收取综合费，逾期5天，典当行有权解除典当关系不再续当，一次性收回剩余当金；3，典当利息每期按剩余本金的0.3%计算，在赎当时或末期一次性支付，按实际续当期数结算典当利息，不满一期按一期收取。4，提前赎当，无违约金。
                </td>
              </tr>
            </table>
          </div>

          <div class="flex_row onSubmit">
            <el-button type="primary" @click="onSubmit">确定建当</el-button>
            <el-button @click="reset">重置</el-button>
            <el-button v-print="'#print'">打印还款表</el-button>
          </div>

          <div>
            <el-button-group>
              <el-button style="margin-top: 12px" @click="isShowType(1)" type="primary"
                >1+N</el-button
              >
              <el-button style="margin-top: 12px" @click="isShowType(2)" type="primary"
                >0+N</el-button
              >
            </el-button-group>
          </div>
        </div>

        <!-- 上一步下一步按钮 -->
        <div class="next_tj">
          <el-button-group>
            <el-button
              style="margin-top: 12px"
              @click="back"
              type="primary"
              icon="el-icon-arrow-left"
              >上一步</el-button
            >
            <el-button style="margin-top: 12px" @click="next" type="primary"
              >下一步<i class="el-icon-arrow-right el-icon--right"></i
            ></el-button>
          </el-button-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "Cars",
  data() {
    return {
      testShow: 1, //显示第几页
      piaonum: "", //票号
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      dates: "", //当前日期时间
      username: "", //当前登录的账号名字
      name: "", //车主名字
      IdCard: "", //身份证号码
      radio: "全款无负债", //车辆状态
      address: "", //车主通信地址
      tel: "", //客户电话
      radio1: "否", //是否事故车
      radio2: "燃油", //能源类型
      creditor: "", //债权人
      price: "", //贷款金额
      repayment: "", //月供
      remaining: "", //剩余贷款金额
      RestPeriods: "", //车贷剩余期数
      total: "", //购车总额
      invoiceCost: "", //发票价
      radios: "轿车", //汽车类型
      transferOwnership: "", //过户次数
      brand: "", //汽车品牌
      plateNumber: "", //车牌号
      models: "", //型号
      engineNumber: "", //发动机号
      vin: "", //车架号
      carColor: "", //车辆颜色
      recordDate: "", //注册日期

      mileage: "", //行驶里程
      checkList: ["车辆登记证书"], //证件

      StrongRisk: "", //交强险
      commercialInsurance: "", //商业险到期日期

      IllegalProcessing: "", //违章情况
      facade: "", //外观
      engine: "", //发动机

      interior: "", //内饰
      chassis: "", //底盘
      coolingSystem: "", //冷却系统
      electricalSystem: "", //电气系统
      brakingSystem: "", //制动系统
      testDrive: "", //试驾情况
      trim: "", //内饰
      energy: "", //剩余能源
      opinion: "", //经办人意见
      values: null, //车况
      texts: ["较差", "一般", "好"],
      NewCarPrice: "", //新车在售价格
      keepValue: "", //保值率
      expect: "", //客户期望借款金额
      vehicles: "", //车300 估值
      residualValue: "", //剩余价值
      atHm: "", //汽车之家估值
      overallValuation: "", //车辆最终估值
      FoldWhen: "", //折当率
      parkingFee: "", //停车费
      sum: "", //典当金额
      detaValue: "", //选择典当日期
      comprehensive: 0, //典当综合费
      lx: 0, //典当利息

      dec: "", //本次典当逾期开始日期
      det: "0", // 选择典当的天数
      pickerOptions: {
        //典当当期
        shortcuts: [
          // {
          //   text: "5天",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     end.setTime(start.getTime() + 3600 * 1000 * 24 * 4);
          //     picker.$emit("pick", [start, end]);
          //   },
          // },
          // {
          //   text: "7天",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     end.setTime(start.getTime() + 3600 * 1000 * 24 * 6);
          //     picker.$emit("pick", [start, end]);
          //   },
          // },
          // {
          //   text: "15天",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     end.setTime(start.getTime() + 3600 * 1000 * 24 * 14);
          //     picker.$emit("pick", [start, end]);
          //   },
          // },
          // {
          //   text: "25天",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     end.setTime(start.getTime() + 3600 * 1000 * 24 * 24);
          //     picker.$emit("pick", [start, end]);
          //   },
          // },
          {
            text: "30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      command: "选择分期", //选择分期
      dateDay: "", //今天的日期，开始日期
      expiringDate: "", //结束日期

      arrNum: [], //选择了几期，循环每一期
      isType: true, //true 是1+N方案，false是0+N方案
      interest: 0, //利息%
      priceZ: 0, // 综合费%
    };
  },
  methods: {
    payDate(event) {
      if (this.isType) {
        return dayjs(this.detaValue[0]).add(event, "day").format("YYYY-MM-DD");
      } else {
        let date = dayjs(this.detaValue[0]).subtract(29, "day");
        return dayjs(date).add(event, "day").format("YYYY-MM-DD");
      }
    },

    next() {
      if (this.testShow < 4 && this.testShow >= 0) {
        this.testShow = this.testShow + 1;
      } else {
        this.$message({
          message: "这已经是最后一页了",
          type: "warning",
        });
      }
    },
    back() {
      if (this.testShow == 1) {
        this.testShow = 1;
      } else {
        this.testShow = this.testShow - 1;
      }
    },
    //切换计算方式
    isShowType(event) {
      if (event == 1) {
        //
        this.isType = true;
      } else {
        this.isType = false;
      }
    },

    //监听车辆购车方式的点击事件
    raDi(e) {
      this.radio = e;
    },

    //证件类型，多选
    checkLists(e) {
      this.checkList = e;
    },
    //能源类型
    raDias(e) {
      this.radio2 = e;
    },
    //监听是否事故车点击事件
    raDia(e) {
      this.radio1 = e;
    },
    //综合
    compreHensive(e) {
      this.values = e;
    },

    //选择日期事件
    //点击计算综合费公式
    chang() {
      if (this.detaValue !== null) {
        this.dec = dayjs(this.detaValue[1]).add(1, "day").format("YYYY-MM-DD");
        this.det = dayjs(this.dec).diff(dayjs(this.detaValue[0]), "day");
      } else {
        this.det = "0";
      }
    },

    //提交建当事件
    onSubmit() {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("car_data").add({data:{
               piaonum:"${this.piaonum}",
               dates:"${this.dates}",
               name:"${this.name}",
               IdCard:"${this.IdCard}",
               radio:"${this.radio}",
               address:"${this.address}",
               tel:"${this.tel}",
               radio1:"${this.radio1}",
               radio2:"${this.radio2}",
               creditor:"${this.creditor}",
               price:"${this.price}",
               repayment:"${this.repayment}",
               remaining:"${this.remaining}",
               RestPeriods:"${this.RestPeriods}",
               total:"${this.total}",
               invoiceCost:"${this.invoiceCost}",
               radios:"${this.radios}",
               transferOwnership:"${this.transferOwnership}",
               brand:"${this.brand}",
               plateNumber:"${this.plateNumber}",
               models:"${this.models}",
               engineNumber:"${this.engineNumber}",
               vin:"${this.vin}",
               carColor:"${this.carColor}",
               recordDate:"${this.recordDate}",
               mileage:"${this.mileage}",
               checkList:"${this.checkList}",
               StrongRisk:"${this.StrongRisk}",
               commercialInsurance:"${this.commercialInsurance}",
               IllegalProcessing:"${this.IllegalProcessing}",
               facade:"${this.facade}",
               engine:"${this.engine}",
               interior:"${this.interior}",
               chassis:"${this.chassis}",
               coolingSystem:"${this.coolingSystem}",
               electricalSystem:"${this.electricalSystem}",
               brakingSystem:"${this.brakingSystem}",
               testDrive:"${this.testDrive}",
               trim:"${this.trim}",
               energy:"${this.energy}",
               opinion:"${this.opinion}",
               values:"${this.values}",
               NewCarPrice:"${this.NewCarPrice}",
               keepValue:"${this.keepValue}",
               expect:"${this.expect}",
               vehicles:"${this.vehicles}",
               residualValue:"${this.residualValue}",
               atHm:"${this.atHm}",
               overallValuation:"${this.overallValuation}",
               FoldWhen:"${this.FoldWhen}",
               parkingFee:"${this.parkingFee}",
               sum:"${this.sum}",
               det:"${this.det}",
               startDate:"${this.detaValue[0]}",
               DateClosed:"${this.detaValue[1]}",
               comprehensive:"${(this.priceZ / 100) * this.sum}",
               lx:"${(this.interest / 100) * this.sum}",
               agent:"${this.username}",
               reviewer:"",
               finance:"",
               CheckTheDate:"",
               command:"${this.command}",
               isType:${this.isType},
               state:"在当",
               priceZ:"${this.priceZ}",
               interest:"${this.interest}"
             }
           })`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$notify({
              title: "建当成功",
              message: "这笔业务已经建当成功了哦",
              type: "success",
            });

            setTimeout(() => {
              this.$router.go(0);
            }, 1500);
          }
        });
    },

    //重置点击事件
    reset() {
      this.$router.go(0);
    },
    //点击选择分期时间
    handleCommand(command) {
      if (this.sum !== "") {
        let commands = command.split("期");

        this.command = commands[0];
        let com = Number(commands[0]) + 1;
        if (commands[0] !== "0") {
          for (let i = 1; i < com; i++) {
            this.arrNum = i;
          }
        } else {
          this.arrNum = [];
        }

        //  let day = Number(commands[0] * 30) - 1
        //    this.expiringDate = dayjs().add(day, 'day').format('YYYY-MM-DD')  //计算到期日期

        // this.det = dayjs(dayjs().add(day, 'day').format('YYYY-MM-DD')).diff(this.dateDay, 'day') //计算典当天数

        //当典当金额不为空时计算综合费和利息
        //  this.comprehensive =  Number(this.sum * 0.02)

        //计算典当利息
        //  this.lx = Number(this.sum * 0.003)
      } else {
        this.$notify({
          title: "警告",
          message: "典当金额不能为空",
          type: "warning",
        });
      }
    },
  },
  // 组件创建时
  created() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //ACCESS_TOKEN
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    this.dates = dayjs().format("YYYY-MM-DD HH:mm:ss"); //获取到今天的日期事件精确到时分秒

    this.dateDay = dayjs().format("YYYY-MM-DD"); //今天的日期

    //获取当前登录的用户数据
    this.getUserToken();
  },
  //组件挂载时
  mounted() {
    setTimeout(() => {
      this.username = this.userData.username;
    }, 800);
  },
};
</script>
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}

table {
  border-collapse: collapse;
}
td {
  height: 35px;
  border: 1px solid black;
  font-size: 18px;
  text-align: center;
}

.cont_head {
  width: 75%;
  height: 55px;
  margin: 0 auto;
  margin-top: 50px;
  background-color: #eeeeed;
  box-shadow: 0 0 9px 0 #00000044;
  border: 1px solid #c5c5c5;
}
.flex_center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.flex_row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.cont_heads {
  width: 70%;
  height: 40px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.con_tens {
  width: 75%;
  margin: 0 auto;
  /* height: 500px; */
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* border-radius: 12px; */
}

.con_na {
  /* 表单头部的空格   */
  margin: 20px auto;
  width: 90%;
}
td input {
  font-size: 19px;
  outline: none;
  border: 0;
  color: #1d1acf;
  width: 90%;
  text-align: center;
}
.carimg {
  width: 100%;
}
#piao {
  height: 25px;
}
.vereist {
  color: #ec0606;
}
.picker {
  width: 80%;
  outline: none;
  border: 0;
  color: #c44257;
}
.btn_tj {
  margin: 10px auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.next_tj {
  display: flex;
  flex-direction: row;
  justify-content: end;
  /* margin: 20px 0; */
}
.onSubmit {
  margin: 20px auto;
}
</style>
